import { render } from "./PosterView.vue?vue&type=template&id=37a6e989&scoped=true"
import script from "./PosterView.vue?vue&type=script&lang=js"
export * from "./PosterView.vue?vue&type=script&lang=js"

import "./PosterView.vue?vue&type=style&index=0&id=37a6e989&scoped=true&lang=css"

import exportComponent from "/Users/erik/code/oliebol/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a6e989"]])

export default __exports__